import { render, staticRenderFns } from "./AlertResults.vue?vue&type=template&id=4a48398e&"
import script from "./AlertResults.vue?vue&type=script&lang=js&"
export * from "./AlertResults.vue?vue&type=script&lang=js&"
import style0 from "./AlertResults.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports